import { Form, Modal, Select, Table } from "antd";
import { useState, useEffect } from "react";
import previewIcon from "./../../../../Assets/svg/table-action-preview.svg";
import cancelX from "../../../../Assets/svg/cancelXbutton.svg";
import { ArrowRightOutlined } from "@ant-design/icons";
import { httpService } from "../../../../services/httpService.service";
import Preview from "../../planning/VisitBoard/TableView/modals/Preview";
import { useForm } from "antd/es/form/Form";
import { formatDate } from "../../../../services/helpFunctions/formatDateAndTime";

const PreviewTableModal = ({ visible, onCancel, roundId }) => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [form] = useForm();

  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [selectedSiteVisit, setSelectedSiteVisit] = useState(null);

  const [loading, setLoading] = useState(false);

  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 576);
  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 576);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const fetchData = () => {
    setLoading(true);
    httpService.get(
      `/api/Site/rounds/preview?projectId=${roundId}`,
      (res) => {
        setData(res?.data ?? []);
        setLoading(false);
      },
      (error) => {
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    if (roundId) {
      fetchData();
    }
  }, [visible, roundId]);

  const columns = [
    {
      title: <span className="styledTitle">Site visit identifier</span>,
      dataIndex: "siteVisitIdentifier",
      key: "siteVisitIdentifier",
      sorter: (a, b) =>
        (a.siteVisitIdentifier ?? "").localeCompare(
          b.siteVisitIdentifier ?? ""
        ),
      render: (record) => <span className="styledDataIndex3">{record}</span>,
    },
    {
      title: <span className="styledTitle">IP</span>,
      dataIndex: "ip",
      key: "ip",
      sorter: (a, b) => (a.ip ?? "").localeCompare(b.ip ?? ""),
      render: (record) => <span className="styledDataIndex3">{record}</span>,
    },
    {
      title: <span className="styledTitle">Date of Target Visit</span>,
      dataIndex: "plannedVisitDate",
      key: "plannedVisitDate",
      sorter: (a, b) =>
        new Date(a.plannedVisitDate ?? 0) - new Date(b.plannedVisitDate ?? 0),
      render: (record) => (
        <span className="styledDataIndex3">{formatDate(record)}</span>
      ),
    },
    {
      title: <span className="styledTitle">Round</span>,
      dataIndex: "roundChanges",
      key: "roundChanges",
      sorter: (a, b) =>
        (a.roundChanges?.[0]?.newRound ?? "").localeCompare(
          b.roundChanges?.[0]?.newRound ?? ""
        ),
      render: (records) =>
        records?.length ? (
          records.map((record, index) => (
            <span key={index} className="styledDataIndex3">
              {record?.newRound} <ArrowRightOutlined /> {record?.oldRound}
            </span>
          ))
        ) : (
          <span className="styledDataIndex3">Never Moved</span>
        ),
    },
    {
      title: <span className="styledTitle"></span>,
      key: "action",
      fixed: isLargeScreen && data.length > 0 ? "right" : undefined,
      render: (text, record) => (
        <div className="actionDiv">
          <img
            src={previewIcon}
            onClick={() => handleTogglePreviewModal(record)}
            style={{ cursor: "pointer" }}
          />
        </div>
      ),
    },
  ];

  const handleTogglePreviewModal = (record) => {
    const siteVisitCardId = record?.siteVisitId;
    setSelectedSiteVisit(siteVisitCardId);
    setShowPreviewModal(!showPreviewModal);
  };

  const handleChange = (key, option) => {
    if (!option) {
      setFilteredData([]);
      return;
    }

    const { label: selectedValue } = option;

    if (selectedValue === "All Visits") {
      setFilteredData([]);
    }
    if (selectedValue === "Moved") {
      const dataFiltered = data.filter(
        (item) => item?.roundChanges?.length > 0
      );
      setFilteredData(dataFiltered);
    } else if (selectedValue === "Never Moved") {
      const dataFiltered = data.filter(
        (item) => item?.roundChanges?.length < 1
      );
      setFilteredData(dataFiltered);
    }
  };

  return (
    <div>
      <Modal
        title={
          <>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "20px",
              }}
            >
              <img
                src={cancelX}
                style={{ marginLeft: "auto", cursor: "pointer" }}
                onClick={onCancel}
                alt="cancelX"
              />
            </div>
            <h2 className="modalHeader">Visits Moved to Another Round</h2>
          </>
        }
        closable={false}
        open={visible}
        onCancel={onCancel}
        footer={[]}
        width={"70%"}
      >
        <Form
          form={form}
          layout="horisontal"
          className="w-100 d-flex justify-content-start"
        >
          <Form.Item>
            <Select
              placeholder="Filter moved site visits..."
              defaultValue={"1"}
              onChange={handleChange}
              style={{ width: "250px" }}
              options={[
                { value: "1", label: "All Visits" },
                { value: "2", label: "Moved" },
                { value: "3", label: "Never Moved" },
              ]}
            />
          </Form.Item>
        </Form>
        <Table
          rowKey="siteVisitIdentifier"
          // rowSelection={rowSelection}
          columns={columns}
          dataSource={filteredData?.length ? filteredData : data}
          loading={loading}
          // pagination={pagination}
          // onChange={handleTableChange}
          scroll={{ x: "max-content" }}
        />
      </Modal>
      <Preview
        visible={showPreviewModal}
        onClose={handleTogglePreviewModal}
        siteVisitCardId={selectedSiteVisit}
      />
    </div>
  );
};

export default PreviewTableModal;
